/**
 * Last-payment status enum, used to decide whether the sidebar shows a payment alert.
 */
const PENDING = 'PENDING';
const SUCCESS = 'SUCCESS';
const FAILED = 'FAILED';

export const lastPaymentStatus = {
  PENDING,
  SUCCESS,
  FAILED,
};
